import React from "react";

const Image = ({
  alt = "",
  src = "",
  style = {},
  className = "",
  width,
  height,
  onErrorSrc = "https://s3.sa-east-1.amazonaws.com/assets-s3.weesutech.com.br/apps/seenc/placeholder_onerror_img.png"
}) => {
  return (
    <img
      alt={alt}
      src={src}
      style={style}
      className={className}
      width={width}
      height={height}
      onError={(event) => {
        if (event.target.src !== onErrorSrc) {
          event.target.src = onErrorSrc;
        }
      }}
      loading="lazy"
    />
  );
}

export default Image;
